import { createContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DATA } from "../data";
import { IOutliner } from "../interface";
import { Viewport } from "../lib";

export interface IOutlinerContext {
    model: IOutliner | null;
    models: Array<IOutliner>;
}

export const OutlinerContext = createContext<IOutlinerContext>({} as IOutlinerContext);

type OutlinerContextProps = {
    viewport: Viewport;
    children?: React.ReactNode;
};

export const OutlinerProvider = ({ children, viewport }: OutlinerContextProps) => {
    const [model, setModel] = useState<IOutliner | null>(null);
    const [models, setModels] = useState<Array<IOutliner>>(DATA.rootOutliner);
    const params = useParams();

    useEffect(() => {
        const loadModel = async (obj: IOutliner) => {
            await viewport.loadModel(obj);
            setModel(obj);
        };

        if (params.modelName && model?.name !== params.modelName) {
            const model = models.find((item) => item.name === params.modelName) || null;

            if (model) {
                loadModel(model);
            } else {
                setModel(null);
            }
        }

        if (model && !params.modelName) {
            setModel(null);
            viewport.model = null;
        }
    }, [model, viewport, params.modelName, models]);

    return (
        <OutlinerContext.Provider
            value={{
                model: model,
                models: models,
            }}
        >
            {children}
        </OutlinerContext.Provider>
    );
};
